{
  "version": 1,
  "scan": "docs/reference/painting-1538-amsterdam-museum.jpg",
  "imageSize": [6692, 4866],
  "notes": [
    "42 western frontage picks locate legible gable/roof masses by eye. Pixel picks are approximate, not a surveyed footprint or proof of storey count.",
    "Street-chainage anchors and transverse depths are reconstruction estimates constrained by the retained streets, water and institutional reservations.",
    "The other rows and all storey counts are explicit estimates. No hidden facade is classified as an empty plot.",
    "West-bank rows oppose the Nieuwendijk row. East-bank plots connect Warmoesstraat homes to water-side rear bodies.",
    "The southern western row shares an estimated plot direction normal to the retained Nieuwendijk frontage. This fits the painted deep roof sequence across quay bends; neither its direction nor the side walls are surveyed medieval boundaries.",
    "2026-10-04: western quay chainages are projected from their former anchor stations onto the straight 1538/1544 image-constrained bank. House identities, painted roof picks and relative width weights are retained; the fitted fronts and depths remain estimates.",
    "The northern western row stops at chainage 44 to retain the separate Hoge Huis corner group and three adjoining frontage bodies; their detailed reconstruction precedes the row.",
    "2026-10-06: the east-bank rows began 30 m up the surviving Warmoesstraat and left the bank bare from there to the dam. The painting draws the houses with their backs on the water from the dam's corner on; four more inferred properties at the same 7 m rhythm carry the row to the surviving street's end, and the street's last stretch to the dam is fronted by the ordinary planner."
  ],
  "rows": [
    {
      "id": "damrak-west-dam-papen",
      "source": "quay-damrak-west",
      "side": "right",
      "from": 521.48,
      "to": 396.725,
      "depth": 34,
      "plotAxis": [-0.828, 0.56],
      "evidence": "painted",
      "houses": [
        {
          "id": "damrak-west-dam-papen-01",
          "widthWeight": 46.86,
          "storeys": 3,
          "roof": "slate",
          "paintedPixel": [3072, 1968]
        },
        {
          "id": "damrak-west-dam-papen-02",
          "widthWeight": 38.89,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3102, 2004]
        },
        {
          "id": "damrak-west-dam-papen-03",
          "widthWeight": 28.04,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3127, 2023]
        },
        {
          "id": "damrak-west-dam-papen-04",
          "widthWeight": 24.6,
          "storeys": 2,
          "roof": "slate",
          "paintedPixel": [3145, 2040]
        },
        {
          "id": "damrak-west-dam-papen-05",
          "widthWeight": 27.32,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3166, 2053]
        },
        {
          "id": "damrak-west-dam-papen-06",
          "widthWeight": 27.2,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [3190, 2071]
        },
        {
          "id": "damrak-west-dam-papen-07",
          "widthWeight": 25.39,
          "storeys": 2,
          "roof": "slate",
          "paintedPixel": [3210, 2085]
        },
        {
          "id": "damrak-west-dam-papen-08",
          "widthWeight": 25.52,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3233, 2098]
        },
        {
          "id": "damrak-west-dam-papen-09",
          "widthWeight": 26.54,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3252, 2114]
        },
        {
          "id": "damrak-west-dam-papen-10",
          "widthWeight": 25.93,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3269, 2137]
        },
        {
          "id": "damrak-west-dam-papen-11",
          "widthWeight": 23.51,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [3292, 2147]
        },
        {
          "id": "damrak-west-dam-papen-12",
          "widthWeight": 23.69,
          "storeys": 2,
          "roof": "slate",
          "paintedPixel": [3310, 2160]
        },
        {
          "id": "damrak-west-dam-papen-13",
          "widthWeight": 33.95,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3326, 2180]
        },
        {
          "id": "damrak-west-dam-papen-14",
          "widthWeight": 38.81,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [3359, 2207]
        },
        {
          "id": "damrak-west-dam-papen-15",
          "widthWeight": 33.56,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3387, 2228]
        },
        {
          "id": "damrak-west-dam-papen-16",
          "widthWeight": 32.25,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [3415, 2244]
        }
      ],
      "opposite": "street-nieuwendijk"
    },
    {
      "id": "damrak-west-papen-oudebrug",
      "source": "quay-damrak-west",
      "side": "right",
      "from": 394.725,
      "to": 195.092,
      "depth": 34,
      "evidence": "painted",
      "houses": [
        {
          "id": "damrak-west-papen-oudebrug-01",
          "widthWeight": 26.91,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3573, 2393]
        },
        {
          "id": "damrak-west-papen-oudebrug-02",
          "widthWeight": 28.36,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3591, 2413]
        },
        {
          "id": "damrak-west-papen-oudebrug-03",
          "widthWeight": 29.3,
          "storeys": 3,
          "roof": "slate",
          "paintedPixel": [3616, 2430]
        },
        {
          "id": "damrak-west-papen-oudebrug-04",
          "widthWeight": 26.91,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3638, 2448]
        },
        {
          "id": "damrak-west-papen-oudebrug-05",
          "widthWeight": 27.28,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3656, 2466]
        },
        {
          "id": "damrak-west-papen-oudebrug-06",
          "widthWeight": 29.13,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [3679, 2484]
        },
        {
          "id": "damrak-west-papen-oudebrug-07",
          "widthWeight": 31.47,
          "storeys": 2,
          "roof": "slate",
          "paintedPixel": [3701, 2503]
        },
        {
          "id": "damrak-west-papen-oudebrug-08",
          "widthWeight": 33.59,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [3724, 2528]
        },
        {
          "id": "damrak-west-papen-oudebrug-09",
          "widthWeight": 31.85,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3748, 2551]
        },
        {
          "id": "damrak-west-papen-oudebrug-10",
          "widthWeight": 30.48,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [3771, 2571]
        },
        {
          "id": "damrak-west-papen-oudebrug-11",
          "widthWeight": 32.22,
          "storeys": 2,
          "roof": "slate",
          "paintedPixel": [3794, 2591]
        },
        {
          "id": "damrak-west-papen-oudebrug-12",
          "widthWeight": 31.83,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3819, 2614]
        },
        {
          "id": "damrak-west-papen-oudebrug-13",
          "widthWeight": 30.41,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [3840, 2635]
        },
        {
          "id": "damrak-west-papen-oudebrug-14",
          "widthWeight": 32.22,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3862, 2657]
        },
        {
          "id": "damrak-west-papen-oudebrug-15",
          "widthWeight": 31.18,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3888, 2678]
        },
        {
          "id": "damrak-west-papen-oudebrug-16",
          "widthWeight": 30.78,
          "storeys": 3,
          "roof": "slate",
          "paintedPixel": [3909, 2698]
        },
        {
          "id": "damrak-west-papen-oudebrug-17",
          "widthWeight": 33.24,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3933, 2720]
        },
        {
          "id": "damrak-west-papen-oudebrug-18",
          "widthWeight": 34.71,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [3957, 2744]
        },
        {
          "id": "damrak-west-papen-oudebrug-19",
          "widthWeight": 35.85,
          "storeys": 3,
          "roof": "slate",
          "paintedPixel": [3985, 2766]
        },
        {
          "id": "damrak-west-papen-oudebrug-20",
          "widthWeight": 39.51,
          "storeys": 3,
          "roof": "slate",
          "paintedPixel": [4012, 2790]
        },
        {
          "id": "damrak-west-papen-oudebrug-21",
          "widthWeight": 38.03,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [4047, 2815]
        },
        {
          "id": "damrak-west-papen-oudebrug-22",
          "widthWeight": 33.97,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [4071, 2838]
        },
        {
          "id": "damrak-west-papen-oudebrug-23",
          "widthWeight": 34.01,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [4097, 2861]
        },
        {
          "id": "damrak-west-papen-oudebrug-24",
          "widthWeight": 33.26,
          "storeys": 2,
          "roof": "slate",
          "paintedPixel": [4122, 2883]
        },
        {
          "id": "damrak-west-papen-oudebrug-25",
          "widthWeight": 35.36,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [4146, 2906]
        },
        {
          "id": "damrak-west-papen-oudebrug-26",
          "widthWeight": 37.48,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [4173, 2932]
        }
      ],
      "opposite": "street-nieuwendijk"
    },
    {
      "id": "damrak-west-oudebrug-nieuwebrug",
      "source": "quay-damrak-west",
      "side": "right",
      "from": 189.935,
      "to": 44,
      "depth": 32,
      "evidence": "inferred",
      "houses": [
        {
          "id": "damrak-west-oudebrug-nieuwebrug-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-02",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-05",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-06",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-07",
          "widthWeight": 1.2,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-08",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-09",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-10",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-11",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-12",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-13",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-14",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-15",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-16",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-17",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "damrak-west-oudebrug-nieuwebrug-18",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        }
      ],
      "opposite": "street-nieuwendijk"
    },
    {
      "id": "nieuwendijk-dam-zout",
      "source": "street-nieuwendijk",
      "side": "right",
      "from": 8,
      "to": 106,
      "depth": 32,
      "evidence": "inferred",
      "houses": [
        {
          "id": "nieuwendijk-dam-zout-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-02",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-dam-zout-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-05",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-06",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-dam-zout-08",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-09",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-10",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-11",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-dam-zout-12",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-13",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-14",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-dam-zout-15",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-dam-zout-16",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        }
      ],
      "opposite": "quay-damrak-west"
    },
    {
      "id": "nieuwendijk-zout-oudebrug",
      "source": "street-nieuwendijk",
      "side": "right",
      "from": 110,
      "to": 320,
      "depth": 34,
      "evidence": "inferred",
      "houses": [
        {
          "id": "nieuwendijk-zout-oudebrug-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-02",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-05",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-06",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-08",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-09",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-10",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-11",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-12",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-13",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-14",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-15",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-16",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-17",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-18",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-19",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-20",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-21",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-22",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-23",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-24",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-25",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-zout-oudebrug-26",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        }
      ],
      "opposite": "quay-damrak-west"
    },
    {
      "id": "nieuwendijk-oudebrug-karnemelk",
      "source": "street-nieuwendijk",
      "side": "right",
      "from": 326,
      "to": 417,
      "depth": 30,
      "evidence": "inferred",
      "houses": [
        {
          "id": "nieuwendijk-oudebrug-karnemelk-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-02",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-05",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-06",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-08",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-09",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-10",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-11",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-12",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-13",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-oudebrug-karnemelk-14",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        }
      ],
      "opposite": "quay-damrak-west"
    },
    {
      "id": "nieuwendijk-karnemelk-nieuwebrug",
      "source": "street-nieuwendijk",
      "side": "right",
      "from": 425,
      "to": 501,
      "depth": 26,
      "evidence": "inferred",
      "houses": [
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-02",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-05",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-06",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-08",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-09",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-10",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-11",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "nieuwendijk-karnemelk-nieuwebrug-12",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        }
      ],
      "opposite": "quay-damrak-west"
    },
    {
      "id": "warmoes-dam-corner",
      "source": "street-warmoesstraat",
      "side": "left",
      "from": 1,
      "to": 29,
      "depth": 22,
      "evidence": "inferred",
      "bank": true,
      "houses": [
        {
          "id": "warmoes-dam-corner-01",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-corner-02",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-corner-03",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "warmoes-dam-corner-04",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        }
      ]
    },
    {
      "id": "warmoes-dam-papen",
      "source": "street-warmoesstraat",
      "side": "left",
      "from": 30,
      "to": 126,
      "depth": 22,
      "evidence": "inferred",
      "houses": [
        {
          "id": "warmoes-dam-papen-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-papen-02",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-papen-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "warmoes-dam-papen-04",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-papen-05",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-papen-06",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "warmoes-dam-papen-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-papen-08",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-papen-09",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-papen-10",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "warmoes-dam-papen-11",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-papen-12",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-dam-papen-13",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        }
      ],
      "bank": true
    },
    {
      "id": "warmoes-papen-paternoster",
      "source": "street-warmoesstraat",
      "side": "left",
      "from": 139,
      "to": 225,
      "depth": 22,
      "evidence": "inferred",
      "houses": [
        {
          "id": "warmoes-papen-paternoster-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-papen-paternoster-02",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-papen-paternoster-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "warmoes-papen-paternoster-04",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-papen-paternoster-05",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-papen-paternoster-06",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "warmoes-papen-paternoster-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-papen-paternoster-08",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-papen-paternoster-09",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-papen-paternoster-10",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "warmoes-papen-paternoster-11",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-papen-paternoster-12",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        }
      ],
      "bank": true
    },
    {
      "id": "warmoes-paternoster-oudebrug",
      "source": "street-warmoesstraat",
      "side": "left",
      "from": 244,
      "to": 326,
      "depth": 22,
      "evidence": "inferred",
      "houses": [
        {
          "id": "warmoes-paternoster-oudebrug-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-paternoster-oudebrug-02",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-paternoster-oudebrug-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "warmoes-paternoster-oudebrug-04",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-paternoster-oudebrug-05",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-paternoster-oudebrug-06",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "warmoes-paternoster-oudebrug-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-paternoster-oudebrug-08",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-paternoster-oudebrug-09",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-paternoster-oudebrug-10",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "warmoes-paternoster-oudebrug-11",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        }
      ],
      "bank": true
    },
    {
      "id": "warmoes-oudebrug-guldehand",
      "source": "street-warmoesstraat",
      "side": "left",
      "from": 345,
      "to": 434,
      "depth": 22,
      "evidence": "inferred",
      "houses": [
        {
          "id": "warmoes-oudebrug-guldehand-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-oudebrug-guldehand-02",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-oudebrug-guldehand-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "warmoes-oudebrug-guldehand-04",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-oudebrug-guldehand-05",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-oudebrug-guldehand-06",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "warmoes-oudebrug-guldehand-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-oudebrug-guldehand-08",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-oudebrug-guldehand-09",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-oudebrug-guldehand-10",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "warmoes-oudebrug-guldehand-11",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-oudebrug-guldehand-12",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        }
      ],
      "bank": true
    },
    {
      "id": "warmoes-guldehand-nieuwebrug",
      "source": "street-warmoesstraat",
      "side": "left",
      "from": 449,
      "to": 503,
      "depth": 22,
      "evidence": "inferred",
      "houses": [
        {
          "id": "warmoes-guldehand-nieuwebrug-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-guldehand-nieuwebrug-02",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "warmoes-guldehand-nieuwebrug-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "warmoes-guldehand-nieuwebrug-04",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-guldehand-nieuwebrug-05",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-guldehand-nieuwebrug-06",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "warmoes-guldehand-nieuwebrug-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "warmoes-guldehand-nieuwebrug-08",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        }
      ],
      "bank": true
    }
  ]
}
